<template>
  <v-app light :class="templateConfig.theme">
    <v-app-bar app extended class="templateBanner"></v-app-bar>
    <v-container
      fluid
      :fill-height="
        templateConfig.theme === 'Template-A' ||
        templateConfig.theme === 'Template-B'
      "
      class="templateContainer"
    >
      <v-main style="padding: 0">
        <v-layout justify-center align-start class="outerCompCont pt-5 pb-5">
          <v-flex xs12 md7 lg6>
            <router-view></router-view>
          </v-flex>
        </v-layout>

        <template
          v-if="
            !merchantConfig.configs.HideTermsAndConditions &&
            templateConfig.theme === 'Template-A'
          "
        >
          <Terms />
        </template>
      </v-main>
    </v-container>
  </v-app>
</template>

<script>
import { mapState } from 'vuex';
import Terms from '../components/Shared/components/Terms/terms.vue';

export default {
  name: 'StandaloneLayout',
  components: {
    Terms,
  },
  data() {
    return {};
  },
  methods: {},
  computed: {
    ...mapState(['merchantConfig', 'templateConfig']),
  },
};
</script>
